"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontXL = exports.fontL = exports.fontS = exports.fontM = void 0;
const styled_components_1 = require("styled-components");
const Typography_1 = require("../tokens/global/Typography");
exports.fontM = (0, styled_components_1.css) `
    font-size: ${Typography_1.typographyTokens.fontSizeM.getVar()};
    font-weight: ${Typography_1.typographyTokens.fontWeightRegular.getVar()};
    line-height: ${Typography_1.typographyTokens.lineHeightM.getVar()};
    font-family: ${Typography_1.typographyTokens.fontFamily.getVar()};
`;
exports.fontS = (0, styled_components_1.css) `
    font-size: ${Typography_1.typographyTokens.fontSizeS.getVar()};
    font-weight: ${Typography_1.typographyTokens.fontWeightRegular.getVar()};
    line-height: ${Typography_1.typographyTokens.lineHeightS.getVar()};
    font-family: ${Typography_1.typographyTokens.fontFamily.getVar()};
`;
exports.fontL = (0, styled_components_1.css) `
    font-size: ${Typography_1.typographyTokens.fontSizeL.getVar()};
    font-weight: ${Typography_1.typographyTokens.fontWeightRegular.getVar()};
    line-height: ${Typography_1.typographyTokens.lineHeightL.getVar()};
    font-family: ${Typography_1.typographyTokens.fontFamily.getVar()};
`;
exports.fontXL = (0, styled_components_1.css) `
    font-size: ${Typography_1.typographyTokens.fontSizeXL.getVar()};
    font-weight: ${Typography_1.typographyTokens.fontWeightRegular.getVar()};
    line-height: ${Typography_1.typographyTokens.lineHeightXL.getVar()};
    font-family: ${Typography_1.typographyTokens.fontFamily.getVar()};
`;
//# sourceMappingURL=typography.styles.js.map